import { c as _c } from "react/compiler-runtime";
import type { FC, SVGProps } from "react";
export const ExpandIcon: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <title>Expand</title>;
    t1 = <path d="M14.293 12.8738L10 17.1667L5.70703 12.8738L6.16699 12.4138L10 16.2468L13.833 12.4138L14.293 12.8738ZM14.293 7.12671L13.833 7.58667L10 3.75366L6.16699 7.58667L5.70703 7.12671L10 2.83374L14.293 7.12671Z" stroke="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};